module.exports = __webpack_public_path__ + "static/fonts/Roboto-Medium.90d1676.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/concierge/font/roboto/Roboto-Medium.woff2
// module id = Nt6V
// module chunks = 0